import React, { Fragment, useState } from 'react';
import Alerts from '../../utils/alerts';
import numeral from 'numeral';
import { makeStyles } from '@material-ui/core/styles';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Grid,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Switch,
    colors,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
    Typography,
    Link,
    Box
} from '@material-ui/core';

import {
    GoogleMap,
    LoadScript,
    Marker,
    InfoWindow,
    InfoBox
} from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '720px'
};

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    }
}));

const UnitLocation = ({ location, openEdition }) => {

    const classes = useStyles();

    return (
        <Fragment>
            <Typography>{location.codigo + " - " + location.nome}</Typography>
        </Fragment>
    )
}

const View = ({ resultSet, open, closeView, changeValues, dependencies, updateDependencies }) => {

    const classes = useStyles();

    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});
    const [activeMarker, setActiveMarker] = useState(null);

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleActiveMarker = (marker) => {
        if (marker === activeMarker) {
            return;
        }
        setActiveMarker(marker);
    };

    const getIconName = (unit) => {
        if (unit && unit.regiao && unit.regiao.marcador) {
            return "/static/images/map/banner-1-" + unit.regiao.marcador + ".png"
        } else {
            return "/static/images/map/banner-1.png"
        }
    }

    const getBase = (rows) => {
        var base = ({ lat: -25.4284, lng: -49.2733 });
        for (let index = 0; index < rows.length; index++) {
            const element = rows[index];
            if (element.longitude && element.latitude) {
                base = { lat: parseFloat(element.latitude), lng: parseFloat(element.longitude) };
                return base
            }
        }
        for (let index = 0; index < rows.length; index++) {
            const element = rows[index];
            if (element.municipio) {
                if (element.municipio.longitude && element.municipio.latitude) {
                    base = { lat: parseFloat(element.municipio.latitude), lng: parseFloat(element.municipio.longitude) };
                    return base
                }
            }
        }
        return base;
    }


    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Unidade
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box my={1}>

                        <Fragment>

                            <LoadScript
                                googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                            >
                                <GoogleMap
                                    mapContainerStyle={containerStyle}
                                    center={getBase(resultSet.rows)}
                                    zoom={12}
                                >

                                    {resultSet.rows.map((location, index) => (

                                        (location.latitude && location.longitude) ? (
                                            <Marker
                                                key={location.id}
                                                icon={getIconName(location)}
                                                scale={2}
                                                title={numeral(location.codigo).format('0000') + '-' + location.nome}
                                                name={location.nome}
                                                position={{ lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) }}
                                                onClick={() => handleActiveMarker(location.id)}
                                            >

                                                {activeMarker === location.id ? (

                                                    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                                        <UnitLocation
                                                            openEdition={() => { }}
                                                            location={location}
                                                        >
                                                        </UnitLocation>
                                                    </InfoWindow>
                                                ) : ""}

                                            </Marker>
                                        ) : (
                                            (location.municipio && location.municipio.latitude && location.municipio.longitude) ? (
                                                <Marker
                                                    key={location.id}
                                                    icon={getIconName(location)}
                                                    scale={2}
                                                    title={numeral(location.codigo).format('0000') + '-' + location.nome}
                                                    name={location.nome}
                                                    position={{ lat: (parseFloat(location.municipio.latitude) + (index * 0.0001)), lng: (parseFloat(location.municipio.longitude) + (index * 0.0001)) }}
                                                    onClick={() => handleActiveMarker(location.id)}
                                                >
                                                    {activeMarker === location.id ? (
                                                        <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                                            <UnitLocation
                                                                openEdition={() => { }}
                                                                location={location}
                                                            >
                                                            </UnitLocation>
                                                        </InfoWindow>
                                                    ) : ""}

                                                </Marker>
                                            ) : (
                                                ""
                                            )
                                        )))}

                                </GoogleMap>
                            </LoadScript>

                        </Fragment >

                    </Box>

                    <Divider />

                    <Box my={1}>
                        <Grid container
                            direction="row"
                            justify="flex-end"
                            alignItems="baseline"
                            spacing={1}  >
                            <Grid item >
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => { closeView() }}>
                                    Fechar
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default View;
